import { useTranslation } from 'react-i18next';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { AlarmZoneMode } from 'shared';
import { AlarmIcon } from 'components/alerts/AlarmIcon';
import { StyledCardContent, StyledCardHead, StyledCardHeadRight } from '../StyledComponents';
import { RowItemHead } from './details/RowItemHead';
import { RowItemButtons } from './RowItemButtons';
import { RowItemPill } from './RowItemPill';

interface ZoneItemProps {
	lockerGateItem: ILockerGateItem;
}

export const ZoneItem = ({ lockerGateItem }: ZoneItemProps) => {
	const { t } = useTranslation();
	const { alarmZoneMode, lockerCount, hasAlarm, isArmed } = lockerGateItem;

	const modeLabel =
		alarmZoneMode === AlarmZoneMode.FullControl
			? t('pages.alerts.alarmZoneModeFull')
			: t('pages.alerts.alarmZoneModeExtend');

	return (
		<>
			<StyledCardContent>
				<StyledCardHead>
					<RowItemHead {...lockerGateItem} />
					<RowItemPill label={modeLabel} color='grey' />
					<StyledCardHeadRight>
						{lockerCount != null && (
							<span>{`${lockerCount} ${t('pages.locations.boxes')}`}</span>
						)}
						{hasAlarm && <AlarmIcon isArmed={!!isArmed} />}
					</StyledCardHeadRight>
				</StyledCardHead>
			</StyledCardContent>
			<RowItemButtons {...lockerGateItem} />
		</>
	);
};
